// extracted by mini-css-extract-plugin
export var Pagination = "ReviewSection-mps-module--Pagination--1e6a5";
export var Reviews = "ReviewSection-mps-module--Reviews--093ac";
export var ReviewsContainer = "ReviewSection-mps-module--ReviewsContainer--b0eb1";
export var write = "ReviewSection-mps-module--write--a1df6";